import { useState, useCallback } from 'react';

interface VideoModalState {
  isOpen: boolean;
  src: string;
}

/**
 * Solution页面Modal状态管理Hook
 * 管理VideoModal的打开/关闭状态
 *
 * @returns {Object} Modal状态和控制函数
 * @property {VideoModalState} videoModal - 视频Modal状态
 * @property {Function} openVideoModal - 打开视频Modal
 * @property {Function} closeVideoModal - 关闭视频Modal
 */
export const useSolutionModals = () => {
  const [videoModal, setVideoModal] = useState<VideoModalState>({
    isOpen: false,
    src: '',
  });

  const openVideoModal = useCallback((src: string) => {
    setVideoModal({ isOpen: true, src });
  }, []);

  const closeVideoModal = useCallback(() => {
    setVideoModal({ isOpen: false, src: '' });
  }, []);

  return {
    videoModal,
    openVideoModal,
    closeVideoModal,
  };
};
